import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["open", "anchorRef", "placement", "modifiers", "portal", "portalElement", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { clsx } from 'clsx';
import { usePopper } from './usePopper';
import { FLIP, PREVENT_OVERFLOW } from './modifiers';
import styles from './styles.module.css';
import { useUiKitTheme } from '../../../theme';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонента для рендера элемента спозиционированного относительно другого элемента
 *
 * @export
 * @param {IPopperProps} { open, anchorEl, children }
 * @returns
 */
export function Popper(_ref) {
  let {
      open,
      anchorRef,
      placement,
      modifiers = [FLIP, PREVENT_OVERFLOW],
      portal = true,
      portalElement,
      children
    } = _ref,
    divProps = _objectWithoutProperties(_ref, _excluded);
  const {
    themeClassName
  } = useUiKitTheme();
  const host = typeof document !== 'undefined' ? portalElement !== null && portalElement !== void 0 ? portalElement : document.body : null;
  const popper = usePopper({
    open,
    anchorRef,
    options: {
      placement,
      modifiers
    }
  });
  if (!host || !open) {
    return null;
  }
  const popperElement = /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, divProps), {}, {
    className: clsx(styles['popper'], divProps.className, themeClassName),
    ref: popper.ref,
    children: children
  }));
  return portal ? /*#__PURE__*/ReactDOM.createPortal(popperElement, host) : popperElement;
}